import { render } from "./PublicLayout.vue?vue&type=template&id=3e522c45"
const script = {}

import exportComponent from "C:\\Users\\B. Software Factory\\Desktop\\pcalderon\\Empresas\\park-bcn-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__